import { classes } from "@/classnames"
import { getEmailLink } from "@/utils"
import classNames from "classnames"
import Link from "next/link"

export const ContactUsEmails = ({ emails }: { emails: string[] }) => {

    return <div className="form-mails flex flex-col gap-[16px] md:gap-[20px] items-start">
        {emails.filter(Boolean).map((email) => <Link
            key={email}
            type="email"
            href={getEmailLink(email)}
            className={classNames(classes.FooterLink14, 'text-text-04')}
        >
            {email}
        </Link>)}

    </div>
}